
export const ink = ['#37270B', '#5C4F47']
export const sand = ['#e7f0c3', '#f0cf85']
export const water = ['#a4d4ae', '#32afa9']
export const wood = ['#3e3838', '#60424c', '#984a59']
export const grass = ['#76D828']